export var UiPopperPlacement = /* @__PURE__ */ ((UiPopperPlacement2) => {
  UiPopperPlacement2["Auto"] = "auto";
  UiPopperPlacement2["AutoStart"] = "auto-start";
  UiPopperPlacement2["AutoEnd"] = "auto-end";
  UiPopperPlacement2["Top"] = "top";
  UiPopperPlacement2["TopStart"] = "top-start";
  UiPopperPlacement2["TopEnd"] = "top-end";
  UiPopperPlacement2["Bottom"] = "bottom";
  UiPopperPlacement2["BottomStart"] = "bottom-start";
  UiPopperPlacement2["BottomEnd"] = "bottom-end";
  UiPopperPlacement2["Right"] = "right";
  UiPopperPlacement2["RightStart"] = "right-start";
  UiPopperPlacement2["RightEnd"] = "right-end";
  UiPopperPlacement2["Left"] = "left";
  UiPopperPlacement2["LeftStart"] = "left-start";
  UiPopperPlacement2["LeftEnd"] = "left-end";
  return UiPopperPlacement2;
})(UiPopperPlacement || {});
export const PopperStrategy = {
  Absolute: "absolute",
  Fixed: "fixed"
};
export const UiPopperPlacementAll = Object.values(UiPopperPlacement);
export { UiPopperPlacement as UiPlacement };
